<template>
    <div class="modal fade" id="div-register-passkey-modal-result" tabindex="-1" aria-labelledby="informLabel" aria-hidden="true">
        <div class="modal-dialog" v-if="this.params.result">
            <div class="modal-content rounded-lg">
                <div class="modal-header border-bottom-0 position-relative">
                    <h4 class="modal-title text-center w-100 pl-4 pr-4">パスキーの設定が完了しました</h4>
                    <button type="button" class="close modal-close-btn" data-dismiss="modal" aria-label="Close" @click="closeAndReloadRegisteredPasskeys()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-center pt-0">
                    <img src="@/assets/img/register-passkey-successfully.png" width="56px"/>
                </div>
                <div class="modal-footer border-top-0 pt-0">
                    <div class="row w-100 justify-content-center">
                        <div class="col-12 col-sm-6 w-100">
                            <button type="button" class="btn btn-sm btn-primary w-100" @click="closeAndReloadRegisteredPasskeys()">OK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-dialog" v-else>
            <div class="modal-content rounded-lg">
                <div class="modal-header border-bottom-0 position-relative">
                    <h4 class="modal-title text-center w-100 pl-4 pr-4">パスキーの設定に失敗しました</h4>
                    <button type="button" class="close modal-close-btn" data-dismiss="modal" aria-label="Close" @click="closeAndReloadRegisteredPasskeys()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-center pt-0">
                    <span class="fs-14px">
                        繰り返しこの画面が表示される場合は<a :href=supportLink target="_blank">こちら</a>をご参照ください。
                    </span>
                </div>
                <div class="modal-footer border-top-0 pt-0">
                    <div class="row w-100 justify-content-center">
                        <div class="col-10 col-sm-8">
                            <button type="button" class="btn btn-sm btn-primary w-100" @click="retryRegisterPasskey()">やり直す</button>
                        </div>
                    </div>
                    <div class="row w-100 justify-content-center">
                        <div class="col-6 col-sm-4">
                            <button type="button" class="btn btn-sm btn-default w-100" @click="closeAndReloadRegisteredPasskeys()">後で設定する</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import ModalPlugin from "@/common/plugins/ModalPlugin.js";
    import ServiceUtils from '@/common/utils/ServiceUtils';
    import Config from "@/services/Config";

    export default {
        name: "RegisterPasskeyModalResult",
        data() {
            return {
                supportLink: Config.getRegisterPasskeySupportLink(),
                params: {
                    result: true,
                }
            }
        },
        mounted() {
            this.listenEvents()
        },
        methods: {
            listenEvents() {
                ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.SHOW_REGISTER_PASSKEY_MODAL_RESULT, (params) => {
                    $('#div-register-passkey-modal-result').modal({backdrop: 'static', keyboard: false});
                    this.params = params;
                    $("#div-register-passkey-modal-result").modal("show");
                });
            },
            async retryRegisterPasskey() {
                await ServiceUtils.waitModalFullyHidden($("#div-register-passkey-modal-result"));
                this.$modal.retryRegisterPasskeyModalResult({retry: true});
            },
            closeAndReloadRegisteredPasskeys() {
                this.$modal.retryRegisterPasskeyModalResult({retry: false});
                $("#div-register-passkey-modal-result").modal("hide");
            },
        }
    }
</script>

<style scoped>
    .modal-close-btn {
        position: absolute;
        top: 1rem;
        right: 1rem;
    }
    .modal {
        z-index: 1051 !important;
    }
</style>
